<mat-sidenav-container class="example-container" autosize>

    <mat-sidenav #sidenav class="example-sidenav" mode="side" opened="true">

        <mat-nav-list>

            <mat-list-item
                    *ngFor="let page of admin;let i = index"
                    [routerLink]="page.path"
                    appHasPermission [hasPermission]="page.permission"
                    [ngClass]="{'selected': page.path === router.url, 'red': false}"
            >

                <div class="sidenav-icon text-center">


                    <i *ngIf="page.icon_type == 'icon'" style="color: white;    font-size: 22px;" class="{{page.icon}}"> </i>
                    <img *ngIf="page.icon_type == 'image'" style="    width: 26px;" src="{{page.icon}}"/>
                    <br>
                    <div style="font-size: 10px; opacity: .8">{{page.title}}</div>
                </div>

            </mat-list-item>


        </mat-nav-list>

    </mat-sidenav>

    <div style="padding-top: 0px;">
        <app-header ></app-header>
        <div>
            <router-outlet #outlet="outlet"></router-outlet>
        </div>
    </div>


</mat-sidenav-container>
<!--<app-footer></app-footer>-->
